<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

@font-face {
  font-family: JETSans-Regular;
  src: url('./assets/fonts/jet-sans/JETSans-Regular.otf') format('opentype');
}

@font-face {
  font-family: JETSans-Bold;
  src: url('./assets/fonts/jet-sans/JETSans-Bold.otf') format('opentype');
}
@font-face {
  font-family: JETSans-BoldItalic;
  src: url('./assets/fonts/jet-sans/JETSans-BoldItalic.otf') format('opentype');
}
@font-face {
  font-family: JETSans-ExtraBold;
  src: url('./assets/fonts/jet-sans/JETSans-ExtraBold.otf') format('opentype');
}
@font-face {
  font-family: JETSans-Italic;
  src: url('./assets/fonts/jet-sans/JETSans-Italic.otf') format('opentype');
}
@font-face {
  font-family: JETSans-Black;
  src: url('./assets/fonts/jet-sans/JETSans-Black.otf') format('opentype');
}

body {
  padding: 0;
  margin: 0;
}

#app {
  --color-orange-1: rgb(255, 128, 0);
  --color-white-1: rgb(255, 255, 255);
  --color-mozzarella-1: rgb(250, 250, 250);
  --color-mozzarella-2: rgb(245, 243, 241);
  --color-mozzarella-3: rgb(239, 237, 234);
  --color-charcoal-1: rgb(36, 46, 48);
  --color-charcoal-2: rgb(126, 125, 125);
  --color-aubergine-1: rgb(91, 61, 91);
  --color-turmeric-1: rgb(246, 194, 67);
  --color-berry-1: rgb(242, 166, 176);
  --color-cupcake-1: rgb(193, 218, 222);
  --color-tomato-1: rgb(247, 94, 40);

  padding: 0;
  margin: 0;

  width: 100%;
  overflow-x: hidden;

  font-family: 'JETSans-Bold', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.nav {
  @media (max-width: $tablet) {
    display: none;
  }
}
h1,
h2,
h3,
h4,
h5 {
  text-transform: none;
  color: var(--color-charcoal-1);
}
h1 {
  font-size: 180px;
  line-height: 180px;
  font-family: 'JETSans-ExtraBold', sans-serif;
  @media (max-width: $tablet) {
    font-size: 100px;
    line-height: 100px;
  }
}
h2 {
  font-size: 100px;
  line-height: 100px;
  font-family: 'JETSans-ExtraBold', sans-serif;
  @media (max-width: $tablet) {
    font-size: 70px;
    line-height: 70px;
  }
}
h3 {
  font-size: 40px;
  line-height: 40px;
  font-family: 'JETSans-Bold', sans-serif;
  @media (max-width: $tablet) {
    font-size: 30px;
    line-height: 30px;
  }
}
h4 {
  font-size: 30px;
  line-height: 30px;
  font-family: 'JETSans-Bold', sans-serif;
  @media (max-width: $tablet) {
    font-size: 25px;
    line-height: 25px;
  }
}
h5 {
  font-size: 22px;
  line-height: 24px;
  font-family: 'JETSans-Bold', sans-serif;
  @media (max-width: $tablet) {
    font-size: 20px;
    line-height: 22px;
  }
}
p {
  font-size: 16px;
  font-family: 'JETSans-Regular', sans-serif;
  color: var(--color-charcoal-1);
}
span {
  font-family: 'JETSans-Bold', sans-serif;
  color: var(--color-charcoal-1);
}
button,
.button {
  font-family: 'JETSans-Bold', sans-serif;
  min-width: 200px;
  padding: 15px;
  border-radius: 30px;
  cursor: pointer;
  border: 2px solid var(--color-charcoal-1);
  color: var(--color-charcoal-1);
  text-decoration: none;
  background-color: transparent;
  font-size: 18px;
  display: inline-block;
  text-align: center;
  &:hover {
    transform: scale(1.1);
  }
}
.dropdown {
  padding: 10px 20px;
  border-radius: 30px;
  font-family: 'JETSans-Regular', sans-serif;
  display: inline-block;
  background-position: 90% 55%;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-size: 18px;
  background-repeat: no-repeat;
  border: 2px solid var(--color-charcoal-1);
  color: var(--color-charcoal-1);
  min-width: 180px;
  background-image: url('./assets/images/down-arrow.svg');
  cursor: pointer;
}
.switch {
  border: 2px solid var(--color-charcoal-1);
  border-radius: 30px;
  height: 20px;
  padding: 5px;
  width: 50px;
  margin: 0 auto;
  cursor: pointer;
  &__indicator {
    background-color: var(--color-charcoal-1);
    border-radius: 50%;
    height: 20px;
    width: 20px;
  }
}
.radio {
  border: 2px solid var(--color-charcoal-1);
  border-radius: 30px;
  height: 20px;
  padding: 5px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  &__indicator {
    border-radius: 50%;
    border: 2px solid var(--color-charcoal-1);
    height: 16px;
    width: 16px;
    cursor: pointer;
    &--chosen {
      height: 10px;
      width: 10px;
      border-radius: 50%;
      margin: 3px;
    }
  }
  .orange {
    background-color: var(--color-orange-1);
  }
  .white {
    background-color: var(--color-white-1);
  }
  .charcoal {
    background-color: var(--color-charcoal-1);
  }
}
.mozzarella {
  background-color: var(--color-mozzarella-3);
}
.tomato {
  background-color: var(--color-tomato-1);
}
.aubergine {
  background-color: var(--color-aubergine-1);
}
.cupcake {
  background-color: var(--color-cupcake-1);
}
.mozzarella-1 {
  background-color: var(--color-mozzarella-1);
}
.mozzarella-2 {
  background-color: var(--color-mozzarella-2);
}
.mozzarella-3 {
  background-color: var(--color-mozzarella-3);
}
.berry {
  background-color: var(--color-berry-1);
}
.turmeric {
  background-color: var(--color-turmeric-1);
}
.charcoal {
  background-color: var(--color-charcoal-1);
}
.orange {
  background-color: var(--color-orange-1);
}
.strong {
  font-family: 'JETSans-Bold', sans-serif;
  margin-bottom: -10px;
}
@keyframes flip-with-scale {
  0% {
    transform: perspective(400px) scaleX(1);
  }
  100% {
    transform: perspective(400px) scaleX(-1);
  }
}
@keyframes unflip-with-scale {
  0% {
    transform: perspective(400px) scaleX(-1);
  }
  100% {
    transform: perspective(400px) scaleX(1);
  }
}
</style>
